import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setError, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'MOTORISTA_DIARIA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setFiltro(filtro = {}) {
    return {
        type: 'MOTORISTA_DIARIA_FILTRO',
        payload: {
			filtro: filtro 
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('motoristaDiariaForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/motoristaDiaria?data=${DateFormat.formatarDataTelaParaParametro(getState().motoristaDiaria.filtro.data)}`).then(resp => {
			dispatch({
				type: 'MOTORISTA_DIARIA_LISTADO',
				payload: resp
			});
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (registro.processar) {
			axios.post(`${consts.API_URL}/motoristaDiaria`, {
				...registro,
				data_diaria: DateFormat.formatarDataTelaParaSql(registro.data_diaria),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else if (!registro.id) {
	        axios.post(`${consts.API_URL}/motoristaDiaria/adicionarMotorista`, {
				...registro,
				data_diaria: DateFormat.formatarDataTelaParaSql(registro.data_diaria),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/motoristaDiaria`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/motoristaDiaria?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/motoristaDiariaTipo/listarSelect`);
    return {
        type: 'MOTORISTA_DIARIA_TIPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'MOTORISTA_DIARIA_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'MOTORISTA_DIARIA_VEICULO_SELECT_LISTADO',
        payload: request
    };
}